import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreateEditWindowComponent } from './create-edit-window.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { State } from '@progress/kendo-data-query';
import { User } from '@app/core/models';


@Component({
  selector: 'detail-receipt',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="960" title="Recibo: {{this.form.value.id}}" *ngIf="opened" (close)="onClose()">
    <form novalidate [formGroup]="form">
      <div class="example-wrapper form-detail">
        
        <div class="row">
          <div class="col-xs-3 col-sm-3 example-col">
                <kendo-label text="Fecha:"></kendo-label>
                <p class="data-info k-color-info">
                  {{this.form.value.date}}
                </p>
            </div>
            <div class="col-xs-6 col-sm-6 example-col">
                <kendo-label text="Cliente:"></kendo-label>
                <p class="data-info k-color-info">
                  {{this.form.value.customer_rfc}} - {{this.form.value.customer_name}}
                </p>
            </div>
            <div class="col-xs-3 col-sm-3 example-col">
                <kendo-label text="Estatus:"></kendo-label>
                <p class="data-info" style="color: white; background-color: #{{this.form.value.status_color}}; text-align: center;">
                  {{this.form.value.status_name}}
                </p>
            </div>
            <div class="col-xs-3 col-sm-3 example-col">
                <kendo-label text="Tipo de pago:"></kendo-label>
                <p class="data-info k-color-info">
                  {{this.form.value.payment_type_name}}
                </p>
            </div>
            <div class="col-xs-6 col-sm-6 example-col">
                <kendo-label text="Recibió:"></kendo-label>
                <p class="data-info k-color-info">
                  {{this.form.value.person_name}}
                </p>
            </div>
            <div class="col-xs-3 col-sm-3 example-col">
                <kendo-label text="Total:"></kendo-label>
                <p class="data-info k-color-success right">
                  {{intl.formatNumber(this.form.value.amount, "c2")}}
                </p>
            </div>
            <div class="col-xs-12 col-sm-12 example-col" *ngIf="this.form.value.status_name == 'CANCELADO'">
                <kendo-label text="Motivo de cancelación:"></kendo-label>
                <p class="data-info k-color-info">
                  {{this.form.value.reason}}
                </p>
            </div>
            
        </div>

        <div class="row py-4">
          <div class="col-xs-12 col-sm-12 example-col">

            <kendo-grid [style.height.%]="100"
              [data]="payments"
              [selectable]="true"
              [reorderable]="true"
              [resizable]="true"
              #grid>

              <kendo-grid-column field="n" title="#" width="60" [filterable]="false">
                <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
                  # {{rowIndex + 1}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="id" title="Id" width="60" [hidden]="true"></kendo-grid-column>
              <kendo-grid-column field="name" title="Concepto" width="250"></kendo-grid-column>
              <kendo-grid-column field="partiality" title="Parcialidad" width="80"></kendo-grid-column>
              <kendo-grid-column field="amount" title="Cantidad" width="120" format="{0:c}" [style]="{'text-align': 'right'}"></kendo-grid-column>      
              <kendo-grid-column field="created" title="Fecha de creación" width="200" [hidden]="true">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">   
                  <kendo-grid-cell-date [text]="dataItem.created" [time]="true"></kendo-grid-cell-date>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="modified" title="Fecha de modificación" width="200" [hidden]="true">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">   
                  <kendo-grid-cell-date [text]="dataItem.modified" [time]="true"></kendo-grid-cell-date>
                </ng-template>
              </kendo-grid-column>

            </kendo-grid>
              
          </div>
        </div>
      </div>
    </form>
  </kendo-window>      
  `,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }
    p.data-info {
      margin-bottom: 0px;
      // font-weight: bold;
      margin-top: 8px;
      padding: 6px;
      // background-color: #ecf0f1;
      border: 1px solid #ecf0f1;
      min-height: 30px;
    }
    p.right {
      text-align: right;
    }
    .k-numeric-wrap .k-input, k-formatted-value{
      text-align:right
    }
  `],
  providers: [ DatasourceService ]
})
export class DetailReceiptComponent extends CreateEditWindowComponent {

  @Input() id: number = 0;

  @Input() type: string = '';

  protected payments: Array<any> = [];

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, protected intl: IntlService) {

    super(authService, service, alertService);    
    
  }

  //@Override
  public edit(dataItem: any, rowIndex: number = null): void {

    this.mode = 'EDIT';
    this.opened = true;
    this.form = this.getFormGroup(this.currentUser, dataItem)
    this.payments = [];

    this.service.post('receipt_pays', { id: dataItem.id})
      .subscribe(
        (res) => {
          console.log("RESPONSE------: ", res);
          this.payments = res.payments;            
        },
        (fail) => {        
          console.log("Error", fail);
        }
      );
  
  }  

  //@Override
  protected getFormGroup(user: User, dataItem?: any): FormGroup {    

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0),
      'date': new FormControl((dataItem) ? dataItem.date: ""), 
      'customer_name': new FormControl((dataItem) ? dataItem.customer_name: ""),
      'customer_rfc': new FormControl((dataItem) ? dataItem.customer_rfc: ""), 
      'amount': new FormControl((dataItem) ? dataItem.amount: ""),  
      'payment_type_name': new FormControl((dataItem) ? dataItem.payment_type_name: ""), 
      'person_name': new FormControl((dataItem) ? dataItem.person_name: ""),  
      'reason': new FormControl((dataItem) ? dataItem.reason: ""), 
      'status_name': new FormControl((dataItem) ? dataItem.status_name: ""), 
      'status_color': new FormControl((dataItem) ? dataItem.status_color: ""), 
    });    

  };


}
